// eslint-disable-next-line max-classes-per-file
import isNil from 'lodash/isNil';
import isNaN from 'lodash/isNaN';
import { Res } from '../Common';
import { GameBookLocationType } from '@/components/tour/game/gameBook/types';

export enum ChapterType {
  Tag = 'tag',
  Polygon = 'polygon',
  VSItem = 'vsItem',
  VSImage = 'vsImage',
  VSVideo = 'vsVideo',
}

export enum GameBookType {
  Open = 'open',
  Close = 'close',
}

class ImageSettings {
  res: Res;

  resMobile: Res;

  width: number;

  height: number;

  widthMobile: number;

  heightMobile: number;

  img: string | null;

  imgMobile: string | null;

  constructor(model: any) {
    this.res = model.res || Res.Percentage;
    this.resMobile = model.resMobile || Res.Percentage;
    this.width = model.width || 80;
    this.height = model.height || 60;
    this.widthMobile = model.widthMobile || 80;
    this.heightMobile = model.heightMobile || 60;
    this.img = model.img || null;
    this.imgMobile = model.imgMobile || null;
  }
}

export class GameBookChapter extends ImageSettings {
  id: number;

  title: string;

  type: ChapterType;

  value: string;

  order: number;

  sweepUuid: string;

  description: string;

  locationTourLink?: string;

  locationType: GameBookLocationType;

  constructor(model: any) {
    super(model);
    this.id = model.id || null;
    this.title = model.title || null;
    this.type = model.type || null;
    this.value = model.value || null;
    this.order = model.order || null;
    this.sweepUuid = model.sweepUuid || null;
    this.description = model.description || null;
    this.locationType = model.locationType || GameBookLocationType.sweep;
    this.locationTourLink = model.locationTourLink || '';
  }
}

export class GameBook extends ImageSettings {
  id: number;

  description: string;

  chapters?: GameBookChapter[];

  gameId: number;

  type: GameBookType;

  chapterLocked: boolean;

  openByDefault: boolean;

  backgroundColor: string;

  backgroundOpacity: number;

  textColor: string;

  buttonColor: string;

  constructor(model: any = {}) {
    super(model);
    this.id = model.id || null;
    this.description = model.description || null;
    this.chapters = model?.chapters?.map((chapter: GameBookChapter) => new GameBookChapter(chapter)) || [];
    this.gameId = model.gameId || null;
    this.type = model.type || GameBookType.Close;
    this.chapterLocked = isNil(model.chapterLocked) ? true : model.chapterLocked;
    this.openByDefault = isNil(model.openByDefault) ? false : model.openByDefault;
    this.backgroundColor = model.backgroundColor || '#000000';
    this.backgroundOpacity = isNaN(model.backgroundOpacity) ? 0.5 : model.backgroundOpacity;
    this.textColor = model.textColor || '#ffffff';
    this.buttonColor = model.buttonColor || '#2055FF';
  }
}
